import { BaseError } from '@or-sdk/base';
export class CreateUserConflictError extends BaseError {
}
//# sourceMappingURL=errors.js.map